import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { PageHeader, Table } from "antd";
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
} from "react-sortable-hoc";

import { setRoute } from "scripts/reducer";
import API from "scripts/api";
import Resources from "scripts/resources";

const DragHandle = SortableHandle(() => <i className="fa fa-bars" />);
const SortableBody = SortableContainer((props) => <tbody {...props} />);
const SortableItem = SortableElement((props) => <tr {...props} />);

const Component = ({ onSetRoute, parentName, routeName }) => {
  const initialState = { data: [] };
  const tableColumns = [
    {
      title: Resources.sort,
      dataIndex: "sort",
      className: "center-cell drag-cell",
      width: 100,
      render: () => <DragHandle />,
    },
    {
      title: Resources.row,
      dataIndex: "index",
      className: "center-cell",
      width: 60,
      render: (value, record, index) => index + 1,
    },
    {
      title: Resources.title,
      dataIndex: "question",
    },
  ];
  const [state, setState] = useState(initialState);
  const { data, loading } = state;

  const handleSort = ({ oldIndex, newIndex }) => {
    if (oldIndex !== newIndex) {
      setState((prevState) => ({ ...prevState, loading: true }));

      const item = data.find((item, index) => index === oldIndex);
      const list = data.filter((item, index) => index !== oldIndex);

      list.splice(newIndex, 0, item);

      API.faq
        .reorder({ ids: list.map((item) => item.id) })
        .then(() => {
          setState((prevState) => ({
            ...prevState,
            data: list,
            loading: false,
          }));
        })
        .catch(() => {
          setState((prevState) => ({ ...prevState, loading: false }));
        });
    }
  };

  const DraggableContainer = (props) => (
    <SortableBody
      useDragHandle
      disableAutoscroll
      helperClass="sp-row-dragging"
      onSortEnd={handleSort}
      {...props}
    />
  );

  const DraggableBodyRow = ({ className, style, ...restProps }) => {
    const index = data.findIndex((x) => x.index === restProps["data-row-key"]);
    return <SortableItem index={index} {...restProps} />;
  };

  const componentDidMount = () => {
    onSetRoute({ openKey: parentName, selectedKey: routeName });

    setState((prevState) => ({ ...prevState, loading: true }));

    API.faq
      .list({ paginate: false })
      .then(({ data }) => {
        setState((prevState) => ({
          ...prevState,
          data: data.map((item, index) => ({ ...item, index })),
          loading: false,
        }));
      })
      .catch(() => {
        setState((prevState) => ({ ...prevState, loading: false }));
      });
  };

  useEffect(componentDidMount, []);

  return (
    <>
      <PageHeader title={Resources.faq} />

      <Table
        columns={tableColumns}
        dataSource={data}
        loading={loading}
        pagination={false}
        rowKey="index"
        components={{
          body: { wrapper: DraggableContainer, row: DraggableBodyRow },
        }}
      />
    </>
  );
};

export default connect(
  (state) => {
    return {};
  },
  (dispatch) => {
    return {
      onSetRoute: (data) => dispatch(setRoute(data)),
    };
  }
)(Component);
